import React, { useEffect, useRef } from 'react';
import { PieChart as PieChartChartist } from 'chartist';
import styles from './style.module.scss';

interface Props {
  data: { percentage: number }[];
}

export default function PieChart({ data }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;
    try {
      new PieChartChartist(ref.current, {
        series: data.map((item, index) => {
          return {
            value: item.percentage,
            className: styles[`section-${index}`],
          };
        }),
      }, {
        showLabel: false,
        width: 260,
        height: 260,
      });
    } catch (e) {
      console.error(e);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current]);

  return <div ref={ref}></div>;
}
